import _ from 'lodash';
import React, { useState, useEffect } from 'react';

import Alert from '~/commons/components/Alert.jsx';

const flattenObject = (any) => {
  const result = {};

  if (typeof any === 'string') {
    return [any];
  }
  if (typeof any === 'object') {
    Object.keys(any).forEach((key) => {
      const value = any[key];
      if (typeof value === 'object') {
        const flatObject = flattenObject(value);
        Object.keys(flatObject).forEach((k) => {
          result[`${key}.${k}`] = flatObject[k];
        });
      } else {
        result[key] = value;
      }
    });
  }

  return result;
};
const messageLimit = 3;
const FormErrorAlert = ({ errors, submitCount }) => {
  if (!submitCount) return '';

  const messages = _.compact(Object.values(flattenObject(errors)));
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(!!Object.keys(errors).length);
  }, [submitCount]);

  const children = messages
    .slice(0, messageLimit)
    .map((message, i) => <div key={i}>{message}</div>);

  if (messages.length > messageLimit) {
    children.push(
      <div key={messageLimit}>
        <small>and {messages.length - messageLimit} more...</small>
      </div>,
    );
  }

  return show ? (
      <Alert theme="danger" onClose={() => setShow(false)}>
        {children}
      </Alert>
  ) : '';
};

export default FormErrorAlert;
